module.exports = __webpack_public_path__ + "static/media/vegitables_24.4c2cfdb4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_24.csv
// module id = 607
// module chunks = 0